var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-button',{staticClass:"btn-my-primary",attrs:{"size":"sm"},on:{"click":function($event){return _vm.toggleTable(_vm.item)}}},[_c('b-icon',{attrs:{"icon":_vm.iconClass}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }